export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10581.a9a2d0c7.jpg";